import { Navigate } from "src/router";
import type { RouteObject } from "src/router";
import type { RoutePreload } from "src/router/route-preloads";
import { lazyNamed } from "src/utils/lazy-named";

import { EventDestinationPermissionsRoute } from "./event-destination-permissions-route";

const CreateEventWarehouseDestination = lazyNamed(
  () => import("./create"),
  "CreateEventWarehouseDestination",
);
const EventDestinationLayout = lazyNamed(
  () => import("./destination"),
  "EventDestinationLayout",
);
const eventDestinationsImport = () => import("./destinations");
const EventDestinations = lazyNamed(
  eventDestinationsImport,
  "EventDestinations",
);

export const preloads: RoutePreload[] = [
  ["/events/destinations", eventDestinationsImport],
];
const Configuration = lazyNamed(
  () => import("./destination/configuration"),
  "Configuration",
);
const SchemaSettings = lazyNamed(
  () => import("./destination/schema-settings"),
  "SchemaSettings",
);

export const routes: Array<RouteObject> = [
  {
    index: true,
    spacesAccess: "hidden-from-limited-view",
    element: <EventDestinations />,
  },
  {
    path: "new",
    spacesAccess: "hidden-from-limited-view",
    element: <CreateEventWarehouseDestination />,
  },
  {
    path: ":id",
    spacesAccess: "hidden-from-limited-view",
    element: <EventDestinationLayout />,
    children: [
      {
        path: "configuration",
        spacesAccess: "hidden-from-limited-view",
        element: <Configuration />,
      },
      {
        path: "sync-settings",
        spacesAccess: "hidden-from-limited-view",
        element: <SchemaSettings />,
      },
      {
        path: "permissions",
        spacesAccess: "hidden-from-limited-view",
        element: <EventDestinationPermissionsRoute />,
      },
      {
        index: true,
        spacesAccess: "hidden-from-limited-view",
        element: (
          <Navigate
            to={{ pathname: "configuration", search: location.search }}
            replace
          />
        ),
      },
    ],
  },
];
